import { isEmpty, isNil, clone, cloneDeep } from 'lodash';
import WebSocketMixin from './WebSocketMixin';
import HotelmeisterMixin from './HotelmeisterMixin';
import uuid from 'uuid';
import ReloadPageMixin from './ReloadPageMixin';

export default {

  mixins: [WebSocketMixin, HotelmeisterMixin, ReloadPageMixin],

  computed: {
    openItems: function () {
      return [];
    },
    historyLength: function () {
      return this.$store.getters['hotel/historyLength'];
    },
    canRouteBack: function () {
      return this.historyLength >= 0 && this.historyLength < window.history.length;
    },
  },

  data: function () {
    return {
      _concurrentEditClosed: null,
      modalOpen: 0,
    };
  },

  watch: {
    openItems: function (newVal) {
      this._updateOpenItems(newVal);
    },
  },

  created() {
    this._concurrentEditClosed = false;
    this._updateOpenItems(cloneDeep(this.openItems));
  },

  beforeDestroy() {
    this._informAboutClose();
  },

  methods: {
    _updateOpenItems(newVal) {
      if (isNil(this._concurrentEditClosed)) return; // meaning not initialized yet
      if (this._concurrentEditClosed) return;

      if (isNil(newVal)) return;

      newVal.forEach((it) => {
        try {
          this.wsSend({
            action: 'ui.request::UiHasOpenRequest',
            id: it.id,
            className: it.className,
            hotelId: this.$store.getters['hotel/hotelId'],
            tabId: this.$root.tabId,
          });
        } catch (e) { /* ignore */ }
      });
    },
    _informAboutClose() {
      if (this._concurrentEditClosed) return;

      const value = cloneDeep(this.openItems);

      if (isNil(value)) return;

      value.forEach((it) => {
        try {
          this.wsSend({
            action: 'ui.request::UiCloseInformation',
            id: it.id,
            className: it.className,
            hotelId: this.$store.getters['hotel/hotelId'],
            tabId: this.$root.tabId,
            user: this.$root.username,
          });
        } catch (e) { /* ignore */ }
      });
    },
    wsHandleMessage(action, data, event) {
      if (this._concurrentEditClosed) return;

      if (!isEmpty(action)) {
        let item = null;
        const $vm = this;
        const goBack = function () {
          if ($vm.canRouteBack) $vm.$router.back();
          else $vm.$router.push({ name: 'home' });
        };

        const reload = function () {
          if ($vm.$options.autosave) {
            $vm.$options.autosave.forEach((it) => {
              $vm.__pauseAutosave(it.name);
            });
          }
          $vm.reloadPage();
        };

        switch (action) {
          case 'ui.request::UiHasOpenRequest':
            item = this.openItems.find(it => it.className === data.data.className && it.id === data.data.id);
            if (item) {
              this.wsSend({
                action: 'ui.request::UiHasOpenResponse',
                id: item.id,
                className: item.className,
                targetTabId: data.data.tabId,
                tabId: this.$root.tabId,
                hotelId: this.$store.getters['hotel/hotelId'],
                user: this.$root.username,
              });
            }
            break;
          case 'ui.request::UiHasOpenResponse':
            item = this.openItems.find(it => it.className === data.data.className && it.id === data.data.id);
            if (item) {
              if (data.data.user === 'guest@kiosk') {
                this.modalOpen++;
                this.showModalConfig({
                  content: this.$t('concurrentEditMixin.guestEditingRightNow', [item.label]),
                  cbCancel: () => { this.modalOpen--; goBack(); },
                  button1: {
                    label: this.$t('concurrentEditMixin.modal.openHere'),
                    onClick: () => {
                      this.openItems.forEach((it) => {
                        this.modalOpen--;
                        this.wsSend({
                          action: 'ui.request::UiCloseRequest',
                          id: item.id,
                          className: item.className,
                          tabId: this.$root.tabId,
                          hotelId: this.$store.getters['hotel/hotelId'],
                          user: this.$root.username,
                        });
                      });
                    },
                  },
                  button2: {
                    label: this.$t('concurrentEditMixin.modal.previousPage'),
                    onClick: () => { this.modalOpen--; goBack(); },
                  },
                });
              } else {
                this.modalOpen++;
                this.showModalConfig({
                  content: this.$t('concurrentEditMixin.otherUserEditingRightNow', [item.label, data.data.user]),
                  cbCancel: () => { this.modalOpen--; goBack(); },
                  button1: {
                    onClick: () => { this.modalOpen--; goBack(); },
                  },
                  button2: {
                    onClick: () => {
                      this.modalOpen--;
                      this.openItems.forEach((it) => {
                        this.wsSend({
                          action: 'ui.request::UiCloseRequest',
                          id: item.id,
                          className: item.className,
                          tabId: this.$root.tabId,
                          hotelId: this.$store.getters['hotel/hotelId'],
                          user: this.$root.username,
                        });
                      });
                    },
                  },
                });
              }
            }
            break;
          case 'ui.request::UiCloseRequest':
            item = this.openItems.find(it => it.className === data.data.className && it.id === data.data.id);
            if (item) {
              this.modalOpen++;
              this.showModalConfig({
                content: this.$t('concurrentEditMixin.closedAsRequestedByUser', [item.label, data.data.user]),
                cbCancel: () => { this.modalOpen--; this._concurrentEditClosed = true; reload(); },
                button1: {
                  onClick: () => { this.modalOpen--; this._concurrentEditClosed = true; reload(); },
                  color: 'orange',
                  icon: 'refresh',
                  label: this.$t('concurrentEditMixin.modal.reload'),
                },
                button2: {
                  onClick: () => { this.modalOpen--; goBack(); },
                  icon: 'close',
                  label: this.$t('concurrentEditMixin.modal.close'),
                },
              });
            }
            break;
          case 'ui.request::UiCloseInformation':
            if (this._concurrentEditClosed) break;
            if (this.modalOpen > 0) {
              this._concurrentEditClosed = true;
              reload();
            }
            break;
          default:
            /* do nothing */
            break;
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/ConcurrentEditMixin.js